// src/lib/api.js

// Pick from env first; fall back to localhost:7000
const ROOT = process.env.REACT_APP_API_ROOT || "http://localhost:7000";

const API_BASE = `${ROOT.replace(/\/$/, '')}/api/public`;

async function j(promise) {
  const res = await promise;
  if (!res.ok) {
    let msg = res.statusText;
    try { msg = await res.text(); } catch (_) {}
    throw new Error(`${res.status} ${msg}`);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  websiteMeta: (id) => j(fetch(`${API_BASE}/websites/${id}/meta`)),
  sectionsByWebsite: (websiteId) => j(fetch(`${API_BASE}/site-contents/by-website/${websiteId}`)),
  resolveSection: (websiteId, slug) => j(fetch(`${API_BASE}/site-contents/resolve/${websiteId}/${slug}`)),
  itemsBySection: (contentId) => j(fetch(`${API_BASE}/content-items/by-content/${contentId}`)),
  itemById: (id) => j(fetch(`${API_BASE}/content-items/${id}`)),
  resolveItem: (contentId, itemSlug) => j(fetch(`${API_BASE}/content-items/resolve/${contentId}/${itemSlug}`)),
  resolveBySlugs: (websiteId, sectionSlug, itemSlug) =>
    j(fetch(`${API_BASE}/content-items/resolve-by-slug/${websiteId}/${sectionSlug}/${itemSlug}`)),
};
